import { render } from "./Campanhas.vue?vue&type=template&id=0e6f46c8&scoped=true"
import script from "./Campanhas.vue?vue&type=script&lang=js"
export * from "./Campanhas.vue?vue&type=script&lang=js"

import "./Campanhas.vue?vue&type=style&index=0&id=0e6f46c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e6f46c8"]])

export default __exports__